import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  themeMode: "dark",
  loading: false,
  license: "",
  userGeolocation: false,
  geoError: {},
};

export const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    setThemeMode: (state, action) => {
      state.themeMode = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setLicense: (state, action) => {
      state.license = action.payload;
    },
    setUserGeoLocation: (state, action) => {
      state.userGeolocation = action.payload;
    },
    setGeoError: (state, action) => {
      state.geoError = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setThemeMode, setLoading, setLicense, setUserGeoLocation, setGeoError } =
  globalSlice.actions;

export default globalSlice.reducer;
